import styled from 'styled-components';
import { Row, Col } from 'react-bootstrap';
import { COLORS } from 'modules/core/theme/colors';
import { STATIC_IMAGE_URLS } from 'modules/core/constants';

import { Label } from '../Label/styles';
import { Adornment } from '../Input/styles';

export const FormRow = styled(Row)`
  align-items: center;

  &:not(:last-of-type),
  .route-one-search-data &,
  .consumer-information-row:not(:last-of-type) & {
    margin-bottom: 6px;
  }

  .mg-btm {
    margin-bottom: 0.25rem;
  }

  .disabled-adornment ${Adornment}:nth-of-type(2) {
    background-color: ${COLORS.GREY_31};
  }

  textarea {
    border-radius: 0.375rem !important;
  }
`;

export const FormLabel = styled(Label)<{ disabled?: boolean; bold?: boolean; dark?: boolean }>`
  position: relative;
  font-weight: ${({ theme: { boldText }, required, disabled, bold }) =>
    (required || disabled || bold) && boldText.dark};
  color: ${({ dark, required, theme }) => (required || dark ? theme.colors['grey-5'] : theme.colors['grey-3'])};
`;

export const SubLabel = styled.span`
  position: absolute;
  top: 1.5em;
  left: 0;
  font-size: ${({ theme: { fontSize } }) => fontSize.mini};
`;

export const ColUI = styled(Col)<{
  $inputPaddingLeft?: number;
  $disableMargin?: string;
}>`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin: ${({ $disableMargin }) => ($disableMargin ? '2px 0' : '2px auto')};
  padding-left: ${({ $inputPaddingLeft }) => $inputPaddingLeft};
`;

export const AISparkles = styled.div`
  display: inline-block;
  background-image: url(${STATIC_IMAGE_URLS.icons.sparkles});
  background-size: cover;
  background-repeat: no-repeat;
  height: 13px;
  width: 14px;
  border: none;
  margin: 0 3px;
`;
